import TransactionHistoryTable from './components/TransactionHistoryTable';

export default function TransactionHistoryPage() {
  return <TransactionHistoryTable />;
}
